module.exports = __webpack_public_path__ + "static/media/icon28.120ce0f6.png";